import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { setRecentUrl } from 'store/appSlice';
import { useAuth } from 'hooks';
import { redirectToLogin } from 'api/authentication';
import { DownloadAppModal } from 'components/common';

function PrivateRoute({ children, location = {}, ...rest }) {
	const dispatch = useDispatch();
	const userData = useAuth();
	const { pathname = null } = location;

	useEffect(
		() => () => {
			/**
			 * to set last visited page url in redux store
			 */
			if (pathname) {
				dispatch(setRecentUrl(pathname));
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[pathname]
	);

	if (userData && userData?.id) {
		return (
			<Route {...rest}>
				{children}
				<DownloadAppModal />
			</Route>
		);
	}
	redirectToLogin();

	return false;
}

PrivateRoute.propTypes = {
	location: PropTypes.object,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default PrivateRoute;
